import { Controller } from '@hotwired/stimulus'

export default class PaginationController extends Controller<HTMLFormElement> {
  declare currentPageValue: number
  declare totalPagesValue: number

  static values = {
    currentPage: Number,
    totalPages: Number,
  }

  handleChange() {
    this.element.requestSubmit()
  }

  updateCurrentPage(event: Event) {
    const target = event.target as HTMLInputElement
    const value = parseInt(target.value, 10)
    if (Number.isNaN(value) || value < 1 || value > this.totalPagesValue) {
      target.value = this.currentPageValue.toString()
      event.preventDefault()
      return false
    } else {
      this.handleChange()
    }
  }
}
